/* eslint-disable no-param-reassign */
import store from '../store'

class Api {
  static get(path, base = undefined) {
    if (base === undefined) base = process.env.VUE_APP_BASE_CLIENT_URL
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', base + path)
      console.log(store.getters.aId, 'BB', store.state.myProfileModule.profileSettings.aId)
      xhr.setRequestHeader('AppId', store.getters.aId || store.state.myProfileModule.profileSettings.aId)
      xhr.setRequestHeader('PageId', store.getters.pageId)
      xhr.setRequestHeader('LangId', store.getters.langId)
      xhr.setRequestHeader('BiskoId', store.getters.biskoId)
      xhr.setRequestHeader('AppReferrer', document.referrer)
      if (store.getters.cpt) {
        xhr.setRequestHeader('CPapToken', store.getters.cpt)
      }
      if (store.getters.cft) {
        xhr.setRequestHeader('CFormToken', store.getters.cft)
      }
      if (store.getters.clientToken || store.state.myProfileModule.clientAccount.token) {
        xhr.setRequestHeader('Authorization', `Bearer ${store.getters.clientToken || store.state.myProfileModule.clientAccount.token}`)
      }
      // eslint-disable-next-line consistent-return
      xhr.onload = () => {
        if (xhr.status < 400) {
          return resolve(xhr)
        }
        reject(xhr)
      }
      xhr.onerror = () => {
        reject(xhr)
      }
      xhr.send()
    })
  }

  static post(path, data, base = undefined) {
    if (base === undefined) base = process.env.VUE_APP_BASE_CLIENT_URL

    return new Promise((resolve, reject) => {
      console.log('PURCHASE PAP1:', path, new Date().getTime())
      const xhr = new XMLHttpRequest()
      xhr.open('POST', base + path)
      console.log(store.getters.aId, 'BB', store.state.myProfileModule.profileSettings.aId)
      xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8')
      xhr.setRequestHeader('AppId', store.getters.aId || store.state.myProfileModule.profileSettings.aId)
      xhr.setRequestHeader('PageId', store.getters.pageId)
      xhr.setRequestHeader('LangId', store.getters.langId)
      xhr.setRequestHeader('BiskoId', store.getters.biskoId)
      xhr.setRequestHeader('AppReferrer', document.referrer)
      if (store.getters.clientToken) {
        xhr.setRequestHeader('Authorization', `Bearer ${store.getters.clientToken}`)
      }
      // eslint-disable-next-line func-names
      // eslint-disable-next-line consistent-return
      xhr.onload = function () {
        if (xhr.status < 400) {
          return resolve(xhr)
        }
        reject(xhr)
      }
      xhr.onerror = () => {
        reject(xhr)
      }
      console.log('PURCHASE PAP2:', path, new Date().getTime())
      xhr.send(JSON.stringify(data))
      console.log('PURCHASE PAP3:', path, new Date().getTime())
    })
  }
}

export default Api
